export default "__VITE_ASSET__$9kFzj2U__"